export enum EnModulo {
    Processo = 1,
    Tarefas = 2,
    MenuLateral = 3
}
